import { WifiOff } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { AnimatePresence, motion } from 'motion/react'
import useGlobalStore from '@/useGlobalStore.ts'
import { cn } from '@/lib/utils.ts'

export default function OfflineBanner({ className }: { className?: string }) {
	const { t } = useTranslation()
	const { isNetworkOnline } = useGlobalStore()

	return (
		<AnimatePresence>
			{!isNetworkOnline && (
				<motion.div
					key="offline-banner"
					initial={{ height: 0, opacity: 0 }}
					animate={{ height: 'auto', opacity: 1 }}
					exit={{ height: 0, opacity: 0 }}
					transition={{ duration: 0.2 }}
					className={cn('overflow-hidden bg-danred text-white select-none', className)}>
					<div className="flex items-center justify-center gap-1.5 py-1 text-xs">
						<WifiOff className="w-3.5 h-3.5" />
						{t("You're offline")}
					</div>
				</motion.div>
			)}
		</AnimatePresence>
	)
}
